import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export const useDeleteLocationTag = () => {
  return useMutation({
    mutationFn: deleteLocationTag,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.locationTags.invalidateAll());
      queryClient.invalidateQueries(queryKeys.locations.invalidateAll());
    },
  });
};

const deleteLocationTag = async (tagId: number) => {
  const response = await requestCCApi({
    url: `/locationTags/${tagId}`,
    method: 'DELETE',
  });

  return response;
};
